var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view"},[_vm._v(" DragTarget ")])
}
var staticRenderFns = []

export { render, staticRenderFns }